import { render, staticRenderFns } from "./HomeNewProducts.vue?vue&type=template&id=57eabec8&scoped=true&"
import script from "./HomeNewProducts.vue?vue&type=script&lang=js&"
export * from "./HomeNewProducts.vue?vue&type=script&lang=js&"
import style0 from "./HomeNewProducts.vue?vue&type=style&index=0&id=57eabec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eabec8",
  null
  
)

export default component.exports